import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ThemeProvider } from './context/ThemeContext'
import { WallpaperProvider } from './context/WallpaperContext'
import { AccentProvider } from './context/AccentContext'
import { CategoryFilterProvider } from './context/CategoryFilterContext'
import { installSelectOnFocus } from './utils/selectOnFocus'

installSelectOnFocus()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <AccentProvider>
        <WallpaperProvider>
          <CategoryFilterProvider>
            <App />
          </CategoryFilterProvider>
        </WallpaperProvider>
      </AccentProvider>
    </ThemeProvider>
  </StrictMode>,
)
